import * as React from 'react';

const PickupWarningMessage = ({ labels , onPickupModalShow  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
        className: "checkout-pickup__no-selection"
    }, labels.noSelection), onPickupModalShow && /*#__PURE__*/ React.createElement("button", {
        className: "checkout-pickup__no-selection-link",
        onClick: onPickupModalShow
    }, labels.noSelectionLink))
;

export { PickupWarningMessage };
//# sourceMappingURL=PickupWarningMessage.js.map
